import './index.scss'
import './console'
import './i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import {SharedStoreProvider} from './state/shared-store-context'
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom'
import {reportWebVitals} from './report-web-vitals'
import {ErrorBoundaryWithNavigate} from './error-boundry'
import {App} from './app'
import {GoogleCallback} from './apps/outof195/modules/auth/services/google-callback'
import {AppleCallback} from './apps/outof195/modules/auth/services/apple-callback'
import {AppRedirectHandler} from './shared/app-redirect-handler'
import {injectBaseSize} from './shared/grid/grid'
import {audioApi} from './shared/audio-api'
import {DialogProvider} from './components/use-dialog'
import {config} from './config'

document.title = config.app.title
injectBaseSize()
audioApi.init()

ReactDOM.createRoot(document.getElementById('root')).render(/*<React.StrictMode><ThemeProvider>*/
    <SharedStoreProvider><DialogProvider><Router><Routes>
    <Route path="auth/google/callback" element={<GoogleCallback/>}/>
    <Route path="auth/apple/callback" element={<AppleCallback/>}/>
    {config.app.rootState ? <>
        <Route path={config.app.rootState} element={
            <Navigate to={`/${config.app.rootState}/____l____e____x____e____r____`} />} />
        <Route path={`${config.app.rootState}/*`} element={
            <ErrorBoundaryWithNavigate>
                <AppRedirectHandler/>
                <App/>
            </ErrorBoundaryWithNavigate>
        }/>
    </> : null}
    <Route path="/*" element={
        <ErrorBoundaryWithNavigate>
            <AppRedirectHandler/>
            <App/>
        </ErrorBoundaryWithNavigate>
    }/>
</Routes></Router></DialogProvider></SharedStoreProvider>
/*</ThemeProvider></React.StrictMode>*/);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
